module.exports = __webpack_public_path__ + "static/kaspc-logo-ae79781018623ecba0ac06e95d4b143c.jpg";